import * as React from 'react';

import {StageIndicator} from 'shells/stage-indicator/stage-indicator';

import styles from './stage-cell.module.css';

type Props = {
    value?:
        | {
              id: string;
              name: string;
              position: number;
              numStagesInStageset: number;
              isDeleted: boolean;
          }
        | null
        | undefined
        | string
        | null
        | undefined;
};

export function CellStage(props: Props) {
    const {value} = props;
    if (!value) {
        return null;
    }

    if (typeof value === 'string') {
        return <div>{value}</div>;
    }

    return (
        <div className={styles['stage-cell']}>
            <div className={styles['stage-name']}>{value.name}</div>
            {value.isDeleted ? null : (
                <StageIndicator
                    currentStage={value.position}
                    numStages={value.numStagesInStageset}
                    // @ts-expect-error
                    stageDeleted={value.isDeleted}
                />
            )}
        </div>
    );
}
